import { render, staticRenderFns } from "./BaseStepperItems.vue?vue&type=template&id=215c5125&scoped=true"
import script from "./BaseStepperItems.vue?vue&type=script&lang=js"
export * from "./BaseStepperItems.vue?vue&type=script&lang=js"
import style0 from "./BaseStepperItems.vue?vue&type=style&index=0&id=215c5125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215c5125",
  null
  
)

export default component.exports